import React, {useState} from 'react';
import MaskedInput from 'react-text-mask';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { ProcessButton, Header } from '../../../components';
import { UserService } from '../../../../support/services/api';
import { setAuthData } from '../../../../support/store/AuthReducer';

function SignUp({
  email, password, setPassword, passwordConfirm, setPasswordConfirm, firstName, setFirstName, lastName, setLastName, whatsapp, setWhatsapp, setStep, setUserExists,
}) {
  const dispatch = useDispatch();
  const [localWhatsapp, setLocalWhatsapp] = useState();


  async function createUser() {
    if (whatsapp.length !== 14) return toast('Whatsapp deve conter apenas números e exatamente 11 caracteres.', { type: toast.TYPE.WARNING });

    if (firstName.length < 3 || lastName.length < 3) return toast('Os nomes devem conter pelo menos 3 caracteres.', { type: toast.TYPE.WARNING });

    if (password !== passwordConfirm) {
      return toast('As senhas não estão identicas.', { type: toast.TYPE.WARNING });
    }
  
    UserService(true)
      .create({
        firstName, lastName, email, whatsapp, password, forceUserName: true,
      })
      .then(({ userId }) => {
        UserService()
          .login({ email, password })
          .then(({ token }) => {
            dispatch(setAuthData({
              userId, token, firstName, lastName, email, whatsapp,
            }));
            setUserExists(true);
          });
      }).catch((err)=>{
        if(err.response?.data?.validation?.keys.includes('whatsapp'))
          return toast('Whatsapp já cadastrado por outro usuário.', { type: toast.TYPE.WARNING }); 
      })

  }
  const next = async () => {
    if ((!firstName || !lastName || !whatsapp || !password)) toast('Preencha todos os campos', { type: toast.TYPE.WARNING });
    else await createUser();
  };
  return (
    <div className="step-container">
      <section className="step-container">
        <Header goBack={() => setStep(1)} />
        <h1 className="step-title">
          Por gentileza, crie seu cadastro:
        </h1>
        <p className="step-subtitle">Salvaremos essas informações para te contactar e para futuros pedidos.</p>

        <div className="floating-label-input">
          <input disabled placeholder="E-mail" id="email" type="e-mail" name="email" value={email} onChange={() => { }} />
          <label htmlFor="email">E-mail</label>
        </div>

        <div className="floating-label-input">
          <input required placeholder="Senha" id="password" type="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <label htmlFor="email">Senha</label>
        </div>

        <div className="floating-label-input">
          <input required placeholder="Confirmar Senha" id="passwordConfirm" type="password" name="passwordConfirm" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} />
          <label htmlFor="email">Confirmar Senha</label>
        </div>

        <div className="step-input-group">
          <div className="floating-label-input">
            <input placeholder="Primeiro nome" id="firstName" type="text" name="firstName" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
            <label htmlFor="firstName">Primeiro nome</label>
          </div>

          <div className="floating-label-input">
            <input placeholder="Último nome" id="lastName" type="text" name="lastName" value={lastName} onChange={(e) => setLastName(e.target.value)} />
            <label htmlFor="lastName">Último nome</label>
          </div>

          <div className="floating-label-input">
            <MaskedInput
              value={localWhatsapp}
              onChange={(e) => {
                const cleaned = (`${e.target.value}`).replace(/\D/g, '');
                setWhatsapp(`+55${cleaned}`);
                setLocalWhatsapp(cleaned);
              }}
              mask={['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              placeholder="Whatsapp"
              id="whatsapp"
              type="text"
              name="whatsapp"
            />
            {/* <input required placeholder="Whatsapp" id="whatsapp" type="text" name="whatsapp" value={formatPhoneNumber(whatsapp)} onChange={(e) => setWhatsapp(e.target.value)} /> */}
            <label htmlFor="whatsapp">Whatsapp</label>
          </div>

        </div>
      </section>
      <ProcessButton text="Cadastrar" action={() => next()} />
    </div>
  );
}

export default SignUp;
